import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, BoxProps, Stack, Tooltip, Typography, useTheme } from "@mui/material";

interface SummaryMetricProps extends BoxProps {
  label: string;
  metric: string;
  byline?: string;
  bylineTooltip?: string;
}

export const SummaryMetric = ({
  label: title,
  metric,
  byline,
  bylineTooltip,
  ...boxProps
}: SummaryMetricProps) => {
  const theme = useTheme();

  return (
    <Box border={`1px solid ${theme.palette.section.border}`} p={2} borderRadius={3} {...boxProps}>
      <Stack spacing={1}>
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="h4" fontWeight={600}>
          {metric}
        </Typography>
        <Stack direction="row" alignItems="center" gap={1}>
          {byline && <Typography variant="body2">{byline}</Typography>}
          {bylineTooltip && (
            <Tooltip
              title={
                <Stack>
                  <Typography variant="body1" fontWeight={600}>
                    Simulation Confidence
                  </Typography>
                  <Typography variant="body2">{bylineTooltip}</Typography>
                </Stack>
              }
            >
              <InfoOutlinedIcon fontSize="small" />
            </Tooltip>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
